import { isMockServices } from 'src/utils';
import { MutationFunction } from '@tanstack/react-query';
import mock from '../utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { ChecklistSyncJob } from './syncTypes';

export interface SyncTenantChecklistParams {
  checklistId: string;
}

export interface SyncTenantChecklistResult {
  success: boolean;
  alreadyRunning: boolean;
  job: ChecklistSyncJob | null;
  message?: string;
}

const syncTenantChecklist: MutationFunction<
  SyncTenantChecklistResult,
  SyncTenantChecklistParams
> = async ({ checklistId }) => {
  if (isMockServices()) {
    return await mock(_mockSyncTenantChecklist, { delay: 800, failureRate: 0 });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SyncTenantChecklistResult>(
    `/checklist-rules/${checklistId}/sync`,
    { method: 'POST' },
  );

  if (response.data) return response.data;

  throw new Error('Failed to queue checklist sync');
};

export default syncTenantChecklist;

const _mockSyncTenantChecklist: SyncTenantChecklistResult = {
  success: true,
  alreadyRunning: false,
  job: null,
  message: 'Checklist sync queued.',
};
